let items = [{
        name: 'Dashboard',
        url: '/v2/dashboard',
        icon: 'cui-dashboard',
        badge: {
            variant: 'primary',
        }
    },
    {
        name: 'Contracts',
        url: '/v2',
        icon: 'icon-star',
        badge: {
            variant: 'primary',
        },
        children: [{
                name: 'Client contracts',
                url: '/v2/contract-client',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Supplier contracts',
                url: '/v2/contract-supplier',
                icon: 'icon-arrow-right',
            }
        ]
    },
    {
        name: 'Case Management',
        url: '/v2',
        icon: 'icon-layers',
        badge: {
            variant: 'primary',
        },
        children: [{
            name: 'Case List',
            url: '/v2/case',
            icon: 'icon-arrow-right',
        }]
    },
    {
        name: 'Work Orders',
        url: '/v2',
        icon: 'icon-basket-loaded',
        badge: {
            variant: 'primary',
        },
        children: [{
                name: 'All Orders',
                url: '/v2/orders',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Preventive Orders',
                url: '/v2/orders/preventive',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Corrective Orders',
                url: '/v2/orders/corrective',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Reactive Orders',
                url: '/v2/orders/reactive',
                icon: 'icon-arrow-right',
            }
        ]
    },
    /* {
        name: 'Asset Management',
        url: '/v2',
        icon: 'icon-wallet',
        badge: {
        variant: 'primary',
        },
        children: [
        {
            name: 'Asset Scheduling',
            url: '/v2/asset-management',
            icon: 'icon-arrow-right',
        }
        ]
    }, */
    {
        name: 'Maintenance Management',
        url: '/v2',
        icon: 'icon-folder-alt',
        badge: {
            variant: 'primary',
        },
        children: [{
                name: 'Maintenance Program',
                url: '/v2/maintenance-program',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Maintenance Schedule',
                url: '/v2/maintenance-schedule',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Lift Inspection Scheduling',
                url: '/v2/asset-management',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Lift Inspection Calendar',
                url: '/v2/lift-inspection-calendar',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Job List',
                url: '/v2/job-list/due',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Job List - Soft FM',
                url: '/v2/job-list-soft-fm',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Job List - Map',
                url: '/v2/job-list-map',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Issue Register',
                url: '/v2/issue-register',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Project Listing',
                url: '/v2/project-listing',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Job List - QR Codes',
                url: '/v2/job-list-qr-codes',
                icon: 'icon-arrow-right',
            },
        ]
    },
    {
        name: 'Finance',
        url: '/v2',
        icon: 'cui-dollar',
        badge: {
            variant: 'primary',
        },
        children: [{
                name: 'General Ledger',
                url: '/v2/general-ledger',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Posting Rules',
                url: '/v2/posting-rules',
                icon: 'icon-arrow-right',
            },
            {
                name: 'AP Invoice',
                url: '/v2/ap-invoice',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Payment Voucher',
                url: '/v2/payment-voucher',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Offset Documents',
                url: '/v2/offset-documents',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Credit Note',
                url: '/v2/credit-note',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Chart Of Accounts',
                url: '/v2/chart-of-account',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Misc Expenses',
                url: '/v2/misc-expenses',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Liquidated Damages',
                url: '/v2/liquidated-damages',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Budget',
                url: '/v2/budget',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Navision File Listing',
                url: '/v2/navision-file',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Navision File Config',
                url: '/v2/navision-file-config',
                icon: 'icon-arrow-right',
            }
        ]
    },
    {
        name: 'Accounts',
        url: '/v2',
        icon: 'icon-people',
        badge: {
            variant: 'primary',
        },
        children: [{
                name: 'Companies',
                url: '/v2/companies',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Roles and Authorisation',
                url: '/v2/roles',
                icon: 'icon-arrow-right',
            },
            {
                name: 'User Access Report',
                url: '/v2/user-access-report',
                icon: 'icon-arrow-right',
                roles: {
                    access: "users_access_report",
                    action: "read"
                }
            },
            {
                name: 'User Duty',
                url: '/v2/user-duty',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Users',
                url: '/v2/users',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Password Management',
                url: '/v2/password-management',
                icon: 'icon-arrow-right',
                roles: {
                    access: "password_management",
                    action: "read"
                }
            },
            {
                name: 'Import Logs',
                url: '/v2/import-logs',
                icon: 'icon-arrow-right',
                roles: {
                    access: "audit_trail",
                    action: "read"
                }
            },
            {
                name: 'Audit Trail',
                url: '/v2/audit-trail',
                icon: 'icon-arrow-right',
                roles: {
                    access: "companies",
                    action: "read"
                }
            },
        ]
    },
    {
        name: 'Audit Trail',
        url: '/settings',
        icon: 'icon-calendar',
        badge: {
            variant: 'primary',
        },
        children: [
            {
                name: 'Audit Trail - Duty Assignment',
                url: '/v2/audit-duty-assignment',
                icon: 'icon-arrow-right',
                roles: {
                    access: "allow_can_view_audit_trail_duty_assignment",
                    action: "allow_can_view_audit_trail_duty_assignment"
                }
            },
            {
                name: 'Audit Trail - Role Setup',
                url: '/v2/audit-trail-role',
                icon: 'icon-arrow-right',
                roles: {
                    access: "allow_can_view_audit_trail_role_setup",
                    action: "allow_can_view_audit_trail_role_setup"
                }
            },
            {
                name: 'Audit Trail - User Activities',
                url: '/v2/audit-trail-user-activities',
                icon: 'icon-arrow-right',
                roles: {
                    access: "allow_can_view_audit_trail_user_activities",
                    action: "allow_can_view_audit_trail_user_activities"
                }
            },
            {
                name: 'Audit Trail - User Info',
                url: '/v2/audit-trail-user-info',
                icon: 'icon-arrow-right',
                roles: {
                    access: "allow_can_view_audit_trail_user_info",
                    action: "allow_can_view_audit_trail_user_info"
                }
            },
        ]
    },
    {
        name: 'Master Tables',
        url: '/settings',
        icon: 'icon-list',
        badge: {
            variant: 'primary',
        },
        children: [
            {
                name: 'Approval Templates',
                url: '/v2/approval-template',
                icon: 'icon-arrow-right',
                roles: {
                    access: "approval_template",
                    action: "read"
                }
            },
            {
                name: 'Maintenance Standard',
                url: '/v2/maintenance-standard',
                icon: 'icon-arrow-right',
                roles: {
                    access: "maintenance_standard",
                    action: "read"
                }
            },
            {
                name: 'Master Brands',
                url: '/v2/master-brands',
                icon: 'icon-arrow-right',
                roles: {
                    access: "master_brands",
                    action: "read"
                }
            },
            {
                name: 'Master Case Requestor Types',
                url: '/v2/requestor-types',
                icon: 'icon-arrow-right',
                roles: {
                    access: "master_case_requestor_type",
                    action: "read"
                }
            },
            {
                name: 'Master Checklist Template',
                url: '/v2/master-checklist-template',
                icon: 'icon-arrow-right',
                roles: {
                    access: "checklist_template_master",
                    action: "read"
                }
            },
            {
                name: 'Master Equipment Structure',
                url: '/v2/master-equipment-structure',
                icon: 'icon-arrow-right',
                roles: {
                    access: "master_equipment_structure",
                    action: "read"
                }
            },
            {
                name: 'Master Notification Templates',
                url: '/v2/config-notification',
                icon: 'icon-arrow-right',
                roles: {
                    access: "master_notification_template",
                    action: "read"
                }
            },
            {
                name: 'Master Service Category',
                url: '/v2/master-service-category',
                icon: 'icon-arrow-right',
                roles: {
                    access: "service_category_master",
                    action: "read"
                }
            },
            {
                name: 'Notification - Event Trigger',
                url: '/v2/config-notification/event-trigger',
                icon: 'icon-arrow-right',
                roles: {
                    access: "master_notification_event_trigger",
                    action: "read"
                }
            },
            {
                name: 'Notification - Parameters',
                url: '/v2/config-notification/parameters',
                icon: 'icon-arrow-right',
                roles: {
                    access: "master_notification_parameter",
                    action: "read"
                }
            },
            {
                name: 'Tax and Versioning',
                url: '/v2/tax-versioning',
                icon: 'icon-arrow-right',
                roles: {
                    access: "tax_and_versioning",
                    action: "read"
                }
            },
            // {
            //     name: 'Time Bracket',
            //     url: '/v2/coming-soon',
            //     icon: 'icon-arrow-right',
            //     roles: {
            //         access: "time_bracket",
            //         action: "read"
            //     }
            // },
            {
                name: 'Vendor Linking',
                url: '/v2/vendor-linking',
                icon: 'icon-arrow-right',
                roles: {
                    access: "vendor_linking",
                    action: "read"
                }
            },
            {
                name: 'Tenant & Site Contacts',
                url: '/v2/tenant-site',
                icon: 'icon-arrow-right',
                roles: {
                    access: "tenant_site",
                    action: "read"
                }
            },
            {
                name: 'Resident Site',
                url: '/v2/resident-site',
                icon: 'icon-arrow-right',
                roles: {
                    access: "resident_site",
                    action: "read"
                }
            }
        ]
    },
    {
        name: 'System Config',
        url: '/settings',
        icon: 'icon-settings',
        badge: {
            variant: 'primary',
        },
        children: [
            {
                name: 'Mapping Report',
                url: '/v2/mapping-report',
                icon: 'icon-arrow-right',
                badge: {
                    variant: 'primary',
                },
                roles: {
                    access: "mapping_report",
                    action: "read"
                }
            },
            {
                name: 'Mobile App Versioning',
                url: '/v2/app-version',
                icon: 'icon-arrow-right',
                roles: {
                    access: "mobile_app_versioning",
                    action: "read"
                }
            },
            {
                name: 'Navision Cronjob Setting',
                url: '/v2/navision-cronjob',
                icon: 'icon-arrow-right',
                roles: {
                    access: "navision_cronjob_setting",
                    action: "read"
                }
            },
            {
                name: 'Operating hours',
                url: '/v2/operating-hours',
                icon: 'icon-arrow-right',
                roles: {
                    access: "operating_hours",
                    action: "read"
                }
            },
            {
                name: 'Reference Table',
                url: '/v2/reference-table',
                icon: 'icon-arrow-right',
                roles: {
                    access: "reference_table",
                    action: "read"
                }
            },
            {
                name: 'Web Column Setting',
                url: '/v2/default-column-settings',
                icon: 'icon-arrow-right',
                roles: {
                    access: "web_column_setting",
                    action: "read"
                }
            },
            {
                name: 'Table Purging',
                url: '/v2/table-purging',
                icon: 'icon-arrow-right',
                roles: {
                    access: "table_purging",
                    action: "read"
                }
            }
        ]
    }
]

if(process.env.VUE_APP_TOKEN_SHOW == 1){
    items.map((item, index) => {
        if ( item['name'] == 'System Config' ) {
            items[index]['children'].push({
                name: 'App Token',
                url: '/v2/app-token',
                icon: 'icon-arrow-right',
                roles: {
                    access: "app_token",
                    action: "read"
                }
            });
        }
    });
}

if(process.env.VUE_APP_UOB_SHOW == 1){
    items.push({
        name: 'UOB Integration',
        url: '/settings',
        icon: 'icon-wallet',
        badge: {
            variant: 'primary',
        },
        children: [
            {
                name: 'Generate QR code',
                url: '/v2/uob-generate-qr',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Notifications',
                url: '/v2/uob-notification',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Transactions',
                url: '/v2/uob-transactions',
                icon: 'icon-arrow-right',
            },
        ]
    })
}

items.push({
    name: 'Utilities Management',
    url: '/v2',
    icon: 'icon-equalizer',
    badge: {
        variant: 'primary',
    },
    children: [{
            name: 'Water Meters',
            url: '/v2/water-meter',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Water Reading Logs',
            url: '/v2/water-reading-logs',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Electricity Meters',
            url: '/v2/electricity-meter',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Electricity Reading Logs',
            url: '/v2/electricity-reading-logs',
            icon: 'icon-arrow-right',
        }
    ]
    },
    {
    name: 'Performance Assessment',
    url: '/v2',
    icon: 'icon-folder-alt',
    badge: {
        variant: 'primary',
    },
    children: [{
            name: 'Data Entry',
            url: '/v2/performance-assessment/data-entry-po',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Settings',
            url: '/v2/performance-assessment/settings',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Reports',
            url: '/v2/performance-assessment/report',
            icon: 'icon-arrow-right',
        }
    ]
    },
    {
    name: 'LMU Adhoc',
    url: '/v2',
    icon: 'icon-folder-alt',
    roles: {
        access: "can_view_lmu_adhoc_menu",
        action: "read"
    },
    badge: {
        variant: 'primary',
    },
    children: [{
            name: 'Approval Request',
            url: '/v2/approval-request',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Parts Replacement Records',
            url: '/v2/parts-replacement',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Incoming Documents',
            url: '/v2/incoming-documents',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Batch Submission Summary',
            url: '/v2/batch-submission-summary',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Notification',
            url: '/v2/lmu-notification',
            icon: 'icon-arrow-right',
        },
        {
            name: 'Address Book',
            url: '/v2/lmu-address-book',
            icon: 'icon-arrow-right',
        },
    ]
},
    {
        name: 'Garuda Integration',
        url: '/v2',
        icon: 'icon-notebook',
        badge: {
            variant: 'primary',
        },
        children: [
            {
                name: 'Facilities Properties',
                url: '/v2/garuda-facilities-properties',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Inspections Jobs',
                url: '/v2/garuda-inspections-jobs',
                icon: 'icon-arrow-right',
            }
        ]
    }
);

let safety_items = [
    {
        name: 'Safety App',
        url: '/v2',
        icon: 'icon-puzzle',
        badge: {
            variant: 'primary',
        },
        children: [
            {
                name: 'Safety Inspection Checklist',
                url: '/v2/safety-inspection-checklist',
                icon: 'icon-arrow-right',
                roles: {
                    access: "safety_inspection_checklist",
                    action: "read"
                }
            },
            {
                name: 'Non Conformance Report',
                url: '/v2/non-conformance-report',
                icon: 'icon-arrow-right',
                roles: {
                    access: "non_conformance_report",
                    action: "read"
                }
            },
            {
                name: 'Permit To Work',
                url: '/v2/permit-to-work',
                icon: 'icon-arrow-right',
                roles: {
                    access: "permit_to_work",
                    action: "read"
                }
            },
            {
                name: 'Safety Induction Training',
                url: '/v2/safety-induction-training',
                icon: 'icon-arrow-right',
                roles: {
                    access: "safety_induction_training",
                    action: "read"
                }
            },
            {
                name: 'Toolbox Meeting',
                url: '/v2/toolbox-meeting',
                icon: 'icon-arrow-right',
                roles: {
                    access: "toolbox_meeting",
                    action: "read"
                }
            }
        ]
    },
    {
        name: 'Safety App Administrator',
        url: '/v2',
        icon: 'icon-settings',
        badge: {
            variant: 'primary',
        },
        children: [
            {
                name: 'Location',
                url: '/v2/location',
                icon: 'icon-arrow-right',
                roles: {
                    access: "safety_app_location",
                    action: "read"
                }
            },
            {
                name: 'Project',
                url: '/v2/safety-app-project',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Assignment',
                url: '/v2/assignment',
                icon: 'icon-arrow-right'
            },
            {
                name: 'Subcontractor',
                url: '/v2/safety-app-subcontractor',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Users',
                url: '/v2/safety-app-users',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Workers',
                url: '/v2/workers',
                icon: 'icon-arrow-right',
                roles: {
                    access: "safety_app_workers",
                    action: "read"
                }
            },
            {
                name: 'Import Logs',
                url: '/v2/import-logs',
                icon: 'icon-arrow-right',
                roles: {
                    access: "audit_trail",
                    action: "read"
                }
            },
        ]
    },
]

items = items.concat(safety_items)

safety_items = [{
    name: 'Dashboard',
    url: '/v2/dashboard',
    icon: 'cui-dashboard',
    badge: {
        variant: 'primary',
    }
}].concat(safety_items)

export default {
    items: items,
    supper: [{
        name: 'Developer',
        url: '/v2',
        icon: 'icon-settings',
        badge: {
            variant: 'primary',
        },
        children: [{
                name: 'All Companies',
                url: '/v2/all-company',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Master Priority Set',
                url: '/v2/master-priority-set',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Time Bracket',
                url: '/v2/coming-soon',
                icon: 'icon-arrow-right',
            },
            {
                name: 'App Version',
                url: '/v2/app-version',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Reference Table',
                url: '/v2/reference-table',
                icon: 'icon-arrow-right',
            },
            {
                name: 'Default Column Settings',
                url: '/v2/default-column-settings',
                icon: 'icon-arrow-right',
            }
        ]
    }],
    safety_items: safety_items
}